import {Component} from '@angular/core';
import {Account, Event, User} from "../../domain/models";
import {ActivatedRoute, Router} from "@angular/router";
import {OpenbandService} from "../../services/openband/openband.service";
import {NotificationService} from "../../services/notifications/notification.service";
import {Title} from "@angular/platform-browser";
import {PreferencesService} from "../../services/preferences/preferences.service";
import {FormBuilder} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {Clipboard} from "@angular/cdk/clipboard";
import {MaskTokenPipe} from "../../helpers/pipes/mask-token.pipe";
import QRCode from 'qrcode';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent {
  users: User[] = [];
  account: Account = new Account();
  maskTokenPipe = new MaskTokenPipe();
  userToCreate: User = new User();
  userToUpdate: User = new User();
  roles = ["user", "admin", "super_admin"]
  events: Event[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: OpenbandService,
    private notifyService: NotificationService,
    private titleService: Title,
    private prefs: PreferencesService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private clipboard: Clipboard,
  ) {
    titleService.setTitle(`Пользователи`)
    this.loadAccount();
    this.getAllEvents()
    route?.queryParams?.subscribe(params => {
        var old = prefs.appPreferences
        var newToken = params['token']
        if (newToken?.length > 3) {
          old.token = newToken
          prefs.setAppPreferences(old)
          this.loadUsers()
        } else {
          this.loadUsers()
        }
      }
    )
  }

  selectUserToUpdate(user: User) {
    this.userToUpdate = user
  }

  loadAccount() {
    this.api.getAccountSettings().subscribe(
      res => this.account = res
    )
  }

  loadUsers() {
    this.api.getUsers().subscribe(
      x => {
        this.users = x
      })
  }

  openCreateEventDialog(content) {
    this.userToCreate = new User();
    this.userToCreate.token = this.generateToken()
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });
  }

  selectEvent(event: Event) {
    this.userToCreate.events.push(+event.id)
  }

  selectEditEvent(event: Event) {
    this.userToUpdate.events.push(+event.id)
  }

  unselectEditEvent(selected: number) {
    this.userToUpdate.events = this.userToUpdate.events.filter(x => x != selected)
  }

  getEventInfo(id: string): string {
    let found = this.events.find(x => x.id == id)
    if (found?.name != null) return `[${found.id}] ${found.name}`; else return found?.id
  }

  // Редактирование пользователя
  editUser(user: User, modal: any): void {
    this.selectUserToUpdate(user)
    this.openEditDialog(modal);
  }

  // Переключение активности
  toggleActive(user: User): void {
    // user.active = !user.active;
    // this.showNotification(`Пользователь ${user.active ? 'активирован' : 'деактивирован'}`);
  }

  // Удаление пользователя
  deleteUser(user: User): void {
    if (confirm(`Вы уверены, что хотите удалить пользователя ${user.username}?`)) {
      this.api.deleteUser(user).subscribe(
        res => {
          this.notifyService.showSuccess('Пользователь удален');
        },
        err => {
          this.notifyService.showError('Ошибка при удалении пользователя');
        }
      )
      this.users = this.users.filter(u => u.username !== user.username);
    }
  }

  private openEditDialog(modal: any): void {
    this.modalService.open(modal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });
  }

  private symbols = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  private generateToken(): string {
    let length = 8
    const values = new Uint32Array(length);
    crypto.getRandomValues(values);
    let token = '';
    for (let i = 0; i < length; i++) {
      token += this.symbols[values[i] % this.symbols.length];
    }

    return token;
  }

  private getAllEvents() {
    this.api.getEventsAll().subscribe(
      res => {
        this.events = res
      },
      error => {

      }
    )
  }

  onSubmitCreateUser(modal: any) {
    this.api.createUser(this.userToCreate).subscribe(
      (result) => {
        this.toastr.success('Пользователь успешно создан');
        this.loadUsers();
        modal.dismiss()
        modal.close();
      },
      (error) => {
        this.toastr.error('Ошибка при создании пользователя');
        console.error('Error creating participant:', error);
      }
    );
  }

  onSubmitUpdateUser(modal: any) {
    this.api.updateUser(this.userToUpdate).subscribe(
      (result) => {
        this.toastr.success('Пользователь успешно обновлён');
        modal.dismiss()
      },
      (error) => {
        this.toastr.error('Ошибка при обновлении пользователя');
        console.error('Error creating participant:', error);
      }
    );
  }

  onChangeUserEditRole(role: string) {
    this.userToUpdate.role = role
  }

  onChangeUserCreateRole(role: string) {
    this.userToCreate.role = role
  }

  copyToken(user: User) {
    this.clipboard.copy(user.token)
    this.notifyService.showSuccess("Токен скопирован в буфер обмена")
  }

  copyLink(user: User) {
    this.clipboard.copy("https://expo.openband.ru/events?token=" + user.token)
    this.notifyService.showSuccess("Ссылка-токен скопирована в буфер обмена")
  }


  async generateQRCode(user: User) {
    try {
      const dataUrl = await QRCode.toDataURL(`https://expo.openband.ru/events?token=${user.token}`, {
        width: 600,
        margin: 1,
        color: {
          dark: '#000000',  // Цвет точек
          light: '#FFFFFF' // Цвет фона
        }
      });

      // Создание временной ссылки для скачивания
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `auth-qr-${user.username}.png`;

      // Триггер скачивания
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (err) {
      console.error('Ошибка генерации QR-кода:', err);
      throw err;
    }
  }
}
